import {Injectable} from '@angular/core';
import {Headers, Http, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {PrivateAccountModel} from './entity';

@Injectable()
export class PrivateAccountService {

    constructor(private _http: Http) {
    }

    createAccount(account: PrivateAccountModel, refCode: string, inviteToken: string): Observable<any> {
        let params = new URLSearchParams();
        params.set('ref', refCode);
        params.set('inviteToken', inviteToken);

        return this._http.post('/api/client/private/register', account, {params: params});
    }

    createUser(user: Object): Observable<any> {
        return this._http.post('/api/client/admin/register', user);
    }

    checkEmail(email: string) {
        let headers = new Headers({'Content-Type': 'application/json'});
        let params = new URLSearchParams();

        let body = {
            email: email
        }

        return this._http.post('/api/client/private/checkEmail', body, {
            headers: headers,
            params: params
        });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/private-account.service.ts